import React from 'react';
import { StudentAnswersContext } from './useProfileProvider';

export const useStudentAnswers = () => {
    const studentAnswers = React.useContext(StudentAnswersContext);

    return studentAnswers;
};
